var map = {
	"./EmployeeRecords.png": 120,
	"./Segmentor.png": 194,
	"./Zimna.png": 421,
	"./belleville-project.png": 808,
	"./eclipsered-project.png": 964,
	"./eclipsered.png": 476,
	"./jeolad.png": 769,
	"./kavodengineering.png": 652,
	"./styvic-project.png": 764,
	"./syrax.png": 819,
	"./yiyara.png": 283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;